import { lazy } from 'react'
// import { Redirect } from 'react-router-dom'
import langConfig from "@configs/langConfig"
const {t} = langConfig

const AppAuth = [
    {
        path: '/login',
        title : t('Login'),
        component: lazy(() => import('../../views/auth/Login')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
            // publicRoute : true
        }
    },
    {
        path: '/register',
        title : t('Register'),
        component: lazy(() => import('../../views/auth/Register')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        }
    },
    {
        path: '/forgot-password',
        title : t('Forgot password'),
        component: lazy(() => import('../../views/auth/ForgotPassword')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        }
    },
    {
        path: '/reset-password',
        title : t('Reset password'),
        component: lazy(() => import('../../views/auth/ResetPassword')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        }
    },
    {
        path: '/verify-user',
        title : t('Verify user'),
        component: lazy(() => import('../../views/auth/VerifyUser')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        }
    },
]

export default AppAuth